export const FT_REQUEST_BASE_URL = import.meta.env
  .REACT_APP_FT_REQUEST_BASE_URL; // provide the base URL for request

export const FT_TSYS_SERVICE_URL = import.meta.env.REACT_APP_TSYS_HOST_URL;
export const FT_SLIMCD_TRANSACTION_URL =
  "https://stats.slimcd.com/soft/json/jsonpayment.asp"; // Change with env var when ready.

export const FT_ASSET_REQUEST_PATH = `${import.meta.env.REACT_APP_ASSETS_DOMAIN}/images/${import.meta.env.REACT_APP_ASSETS_TENENT}/default/payment_center/`;
export const FT_ASSETS_PATH = `${import.meta.env.REACT_APP_ASSETS_DOMAIN}/assets/${import.meta.env.REACT_APP_ASSETS_TENENT}/`;

export const FT_GET_TOKEN = "users/guest";

export const FT_QUICK_PAY_LOAN_FETCH = "payment-center/account-information";
// Placeholder for non-validated account fetch endpoint. This will be replaced with the actual endpoint when it is available.
export const FT_QUICK_PAY_NON_VALIDATED_FETCH =
  "payment-center/account-information/non-validated";
export const FT_USERS = "users";
export const FT_USERS_EMAIL = "users/email";
export const FT_USERS_MFA = "users/mfa";
export const FT_USERS_RESETPASSWORD = "users/password-reset";
export const FT_USERS_CREATE = "users/registrations";
export const FT_USERS_VERIFICATION = "users/registrations/verification";
export const FT_USERS_PAYMENT_CENTER_INFO = "users/payment-center";

export const FT_ADD_PAYMENT_METHOD = "payment-center/paymentMethod";
export const FT_PAYMENT_METHODS = "payment-center/paymentMethod";
export const FT_PAYMENT_METHOD_AUTH = "payment-center/paymentMethodAuth";
export const FT_PAYMENT_FEES_CONFIG = "payment-center/fees";

export const FT_PAYMENT_ACTIVITY = "payment-center/paymentActivity";
export const FT_STATEMENTS = "payment-center/statements";

export const FT_CLIENT_CONFIG = "clients/FT_CLIENT_KEY/config";
export const FT_PAYMENT_CENTER_CONFIG =
  "payment-center/configuration/FT_CLIENT_KEY";

export const FT_TSYS_CONFIG = "ewallet/tsys-config";
export const FT_EWALLET_CONFIG = "ewallet/config/FT_CLIENT_KEY";
export const FT_EWALLET_APPLEPAY = "ewallet/apple-pay/session";
export const FT_AUTO_PAY = "scheduled-payments/recurring";
export const FT_PAY_BY_TEXT = "payment-center/paybytext";
export const FT_SCHEDULE_PAYMENT = "scheduled-payments";
export const FT_ACCOUNT_LOOKUP = "payment-center/account-information";
export const FT_ACCOUNT_ATTACH = "payment-center/account-information/attach";
export const FT_PROCESS_PAYMENT = "payment-center/payment";
export const FT_RECEIPT = "payment-center/paymentActivity/receipt";

export const FT_NOTIFICATIONS_CONFIG = "notifications/config/FT_CLIENT_KEY";
